import { createClient } from "@supabase/supabase-js";
import { Database } from './database.types';

const supabaseUrl = "https://quqqktnzdxwqccikhysf.supabase.co";
const supabaseKey = "sb_publishable_WSrCOvLc8EsDXIKxMumwlA_i2JDN5T_";

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);